export default __webpack_public_path__ + "be14f369a0a3eb0ec5eb0a2fa55fc4a0.svg";